import React from 'react';

export default function AddressTooltip(props) {
	// console.log('AddressTooltip', props);
	return (
		<div className="px-3 py-2 font-semi-bold text-sm">
			<div>670323 Kiapoko Pl</div>
			<div>Waialua, HI 96791</div>
		</div>
	);
}
